import { EMPTY, concat, merge, of } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import Global from '../../store/global-selectors';
import get from 'lodash.get';
import set from 'lodash.set';
import { emptyArray } from 'ui-components/default-props/empty';

import { FulfillmentPlanService } from '../../services/fulfillment-plan-service';
import { doesFulfillmentPlanNeedServiceMappingApplied } from '../../services/requested-service-mapping/does-fulfillment-plan-need-service-mapping-applied';
import { updateCSWwithSavedMappings$ } from '../../store/map-requested-service/map-requested-service.observables';
import * as SellerActions from '../../store/seller/seller.actions';
import * as MapRequestedServiceActions from '../../store/map-requested-service/map-requested-service.actions';

import * as CSWActions from './csw.actions';

import { fulfillmentPlanToCSW } from './csw.fulfillment-plan-to-csw';

const mapRequestedServiceToDraftShipments = (_, storeGuid, salesOrderId, state, updatePayload) => {
  const requestedService = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'requestedService',
  });
  const storeServiceMappings = Global.selectSellerStoreServiceMappings(state, { storeGuid }) || [];
  const storeServiceMapping = storeServiceMappings.find((mapping) => mapping.requestedServiceCode === requestedService);

  if (storeServiceMapping) {
    const { labelProviderId } =
      Global.selectSellerServiceById(state, {
        serviceId: storeServiceMapping.serviceId,
      }) || {};
    const sellerLabelProviders = Global.selectSellerLabelProviders(state) || [];
    const { sellerLabelProviderId } =
      sellerLabelProviders.find((labelProvider) => labelProvider.labelProviderId === labelProviderId && labelProvider.isPrimaryAccount) ||
      {};

    if (storeServiceMapping.packageTypeId) {
      const serviceMappingPackage = Global.selectSellerPackages(state).find(
        (pkg) => pkg && pkg.packageTypeId === storeServiceMapping.packageTypeId,
      );
      return {
        ...updatePayload,
        serviceId: storeServiceMapping.serviceId,
        sellerLabelProviderId,
        packages: serviceMappingPackage ? [serviceMappingPackage] : [],
      };
    }
    return {
      ...updatePayload,
      serviceId: storeServiceMapping.serviceId,
      sellerLabelProviderId,
    };
  }
  return updatePayload;
};

export const persistOrderConfiguration$ = (action$, getState, action) => {
  const state = getState();
  const { fulfillmentPlanId } = action;
  const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(state, {
    fulfillmentPlanId,
  });
  if (!fulfillmentPlan || !fulfillmentPlanId) {
    return EMPTY;
  }
  const accountPackages = Global.selectSellerPackages(state) || emptyArray;
  if (!fulfillmentPlan.sellerLabelProviderId && fulfillmentPlan.serviceId) {
    const services = Global.selectSellerServices(state) || emptyArray;
    const selectedService = services.find((service) => service.serviceId === fulfillmentPlan.serviceId);
    const sellerLabelProviderId = get(selectedService, 'sellerLabelProviderId');
    set(fulfillmentPlan, 'sellerLabelProviderId', sellerLabelProviderId);
  }

  const CSWShippingConfiguration = Global.selectCSWShippingConfiguration(state, { fulfillmentPlanId });
  let updatePayload = fulfillmentPlanToCSW(fulfillmentPlan, accountPackages, CSWShippingConfiguration, get(action, 'type'), getState());
  const [salesOrderId] = fulfillmentPlan?.salesOrdersFulfilledIds ?? [];
  const storeGuid = Global.selectEntitiesSalesOrderProperty(state, {
    salesOrderId,
    property: 'store.storeGuid',
  });

  const mapRequestedService$ = merge(
    action$.pipe(
      ofType(SellerActions.GET_SERVICE_MAPPINGS_SUCCESS),
      take(1),
      mergeMap((successAction) => updateCSWwithSavedMappings$(getState, successAction)),
    ),
    of(MapRequestedServiceActions.mapRequestedServiceSuccess({ storeGuid })),
  );

  if (doesFulfillmentPlanNeedServiceMappingApplied(fulfillmentPlan)) {
    updatePayload = mapRequestedServiceToDraftShipments(fulfillmentPlan, storeGuid, salesOrderId, state, updatePayload);
  }

  if (FulfillmentPlanService.isExternal(fulfillmentPlan)) {
    return concat(
      of(
        CSWActions.setupShipmentConfiguration(fulfillmentPlanId, updatePayload, {
          isExternalFulfillment: true,
        }),
      ),
    );
  }

  return concat(
    of(
      CSWActions.setupShipmentConfiguration(fulfillmentPlanId, updatePayload, {
        isExternalFulfillment: false,
      }),
    ),
    mapRequestedService$,
  );
};
